import * as lang_en from "./locale/en.json";
import * as lang_de from "./locale/de.json";
import * as lang_pl from "./locale/pl.json";
import * as lang_fr from "./locale/fr.json";
import * as lang_es from "./locale/es.json";
import Commons from "./utils/Commons";
import StateGlobal from "./StateGlobal";

class Config
{

    // Application mode [true | false]
    static appMode = {
        dev: false
    }

    static rcwAppDocumentation = "https://docs.boc-group.com/adonis/en/modules/RCW/";

    static myInstance = null;

    static getProductName(){
        const productData = JSON.parse(localStorage.getItem('ado_version'));
        return productData.productName;
    }

    /**
     * Singleton class
     */
    static getConfig()
    {
        if (Config.myInstance == null)
        {
            Config.myInstance = new Config();
        }
        return Config.myInstance;
    }

    static getBreadcrumbsLvl() {

        const breadcrumbsIndex = StateGlobal._currentBradCrumbs.length;
    
        if (breadcrumbsIndex > 0) {
            return `$lvl_${breadcrumbsIndex}`;
        } else {
            return "$element";
        }
    }
    

    constructor()
    {

        if (!Config.lang.selected || !localStorage.getItem("lang"))
        {
            const sLangToSet = localStorage.getItem("lang") || Config.lang.default;
            Config.setLang(sLangToSet);
            localStorage.setItem("lang", sLangToSet);
        }
    }

    // --------------------------------------------------------------------------------------------------------------

    /**
     * Setting language (default english)
     * @param {string} sLang 
     */
    static setLang = (sLang) =>
    {
        if (!Config.lang.allowed.includes(sLang))
        {
            console.warn("'" + sLang + "'" + " is wrong language code. Falling back to default (" + Config.lang.default+").");
            sLang = Config.lang.default;
        }
        if (
            !Config.langFileMap.hasOwnProperty(sLang) || !Config.langFileMap[sLang] || ("object" !== typeof Config.langFileMap[sLang]) ||
            !Config.langFileMap[sLang].hasOwnProperty("strings") || ("object" !== typeof Config.langFileMap[sLang].strings)
        )
        {
            console.error("Cannot find proper file for '" + sLang + "' language!");
            return;
        }
        Config.strings = Config.langFileMap[sLang].strings;

        for (let sKey in Config.stringsLangRepoSpecific[sLang])
        {
            Config.strings[sKey] = Config.stringsLangRepoSpecific[sLang][sKey];
        }
        Config.lang.selected = sLang;
        Config.langData = Config.lang.allowed.map(sLangAllowed =>
        {
            return {
                id: sLangAllowed,
                label: Config.langFileMap[sLangAllowed].strings.selfLabel
            }
        });
    }

    static getLangName = (aItemData) =>
    {
        if (Object.hasOwnProperty.call(aItemData, 'aDisplayName'))
        {
            if (Object.hasOwnProperty.call(aItemData.aDisplayName, Config.lang.selected))
            {
                return aItemData.aDisplayName[Config.lang.selected];
            }
            if (Object.hasOwnProperty.call(aItemData.aDisplayName, Config.lang.default))
            {
                return aItemData.aDisplayName[Config.lang.default];
            }
        }
        return null;
    }

    static getConfigEnv = () =>
    {
        const sConfigFileUrl = window.location.origin + "/getserverenv";
        return new Promise((resolve, reject) =>
        {
            try
            {
                fetch(sConfigFileUrl).then(async (aResult) =>
                {
                    if (aResult.status === 200)
                    {
                        aResult.json().then(aJsonConfig =>
                        {
                            if (aJsonConfig)
                            {
                                Config.env = aJsonConfig;
                                resolve();
                            }
                        });
                    }
                    else
                    {
                        resolve();
                    }
                });
            }
            catch (aEx)
            {
                console.error(aEx);
                resolve();
            }
        });
    }

    // --------------------------------------------------------------------------------------------------------------

    static env = null;

    // --------------------------------------------------------------------------------------------------------------

    /**
     * Rest requests URLs
     */
    static OAuth = {
        taskpane: window.location.origin.concat('/taskpane.html'),
        token: "/oauth2/token"
    }

    static anpRequestUrl = {
        me: "/rest/3.0/me",
        testAuth: "/rest/2.0/version",
        getUser: "/rest/2.0/users/%identification_method%/%identifier%",
        shareUser: "/rest/2.0/users/%identification_method%/%identifier%/shared-repos",
        getModelGroup: "/rest/2.0/repos/%repo_id%/modelgroups/%group_id%?recursive=true&icon=true",
        getRepo: "/rest/2.0/repos",
        getObjectGroup: "/rest/2.0/repos/%repo_id%/objectgroups/%group_id%?recursive=true&icon=true",
        getQueries: "/rest/2.0/repos/%repo_id%/search/saved-queries",
        getQuery: "/rest/2.0/repos/%repo_id%/search/saved-queries/%query_id%?saved-attributes=true",
        getObjectDoc: "/rest/2.0/repos/%repo_id%/objects/%obj_id%/attributes/%attr_name%",
        createObjectGroup: "/rest/2.0/repos/%repo_id%/objectgroups",
        createObject: "/rest/2.0/repos/%repo_id%/objects",
        createEndpoint: "/rest/2.0/repos/%repo_id%/objects/%object_id%/relations/%direction%/%rel_name%",
        attachDoc: "/rest/2.0/repos/%repo_id%/objects/%object_id%/attributes/%attribute_name%",
        getMetamodel: "/rest/2.0/metamodel?all=true",
        getMetaIconModeltype: "/rest/2.0/metamodel/modeltypes/%entity_id%/icon",
        getMetaIconClass: "/rest/2.0/metamodel/classes/%entity_id%/icon"
    }

    static requestDirect = null;
    static requestDirectPutFile = null;
    static requestSession = null;
    static requestSessionLogout = null;

    static requestEngine = null;

    static buildRequestUrls = () =>
    {
        if (Config.env && Config.env.GATEWAY_URL && "string" === typeof Config.env.GATEWAY_URL)
        {
            Config.requestDirect = Config.env.GATEWAY_URL.concat('/direct');
            Config.requestDirectPutFile = Config.env.GATEWAY_URL.concat('/direct/putfile');
            Config.requestSession = Config.env.GATEWAY_URL.concat('/session');
            Config.requestSessionLogout = Config.env.GATEWAY_URL.concat('/session/logout');

            Config.requestEngine = Config.env.ENGINE_URL
        }
    }

    static baseURL = localStorage["baseURL"] || "";
    static setUrlAdo = (sUrl) =>
    {
        Config.baseURL = sUrl;
        localStorage["baseURL"] = sUrl;
    }

    // --------------------------------------------------------------------------------------------------------------

    static sReportNameBase = 'WRC_Report_';
    static nMaxActiveReportReq = 3;

    // --------------------------------------------------------------------------------------------------------------

    static sAnpTemplateObjGroup = "Report Templates WRC";
    static sAnpTopObjectGroupId = "root"; // "4b49163b-4cb5-452a-9a42-62ef359613f4";
    static aAnpRepo = {
        id: null,
        name: null
    };
    static reposAvailable = [];
    static aTemplates = null;
    static aEntities = {
        objects: null,
        models: null,
        queries: null
    };
    static setReposAvailable = (aData) =>
    {
        if (!aData || !Array.isArray(aData) || !aData.length)
        {
            console.error("Cannot set list ofa available repositories because passed list is incorrect!");
        }
        const aDataFiltered = aData.filter((aItem) =>
        {
            return aItem.id && "string" === typeof aItem.id && aItem.name && "string" === typeof aItem.name;
        }).map((aItem) =>
        {
            return {
                id: Commons.removeCurlyBracketsFromId(aItem.id),
                name: aItem.name
            }
        });
        if (aDataFiltered && Array.isArray(aDataFiltered))
        {
            Config.reposAvailable = aDataFiltered;
        }
    }
    static setRepo = (aData) =>
    {
        if (!(aData && aData.hasOwnProperty("id") && "string" === typeof aData.id && 0 < aData.id.length))
        {
            throw new Error("Cannot set repo to Config object! Repo ID: " + ((aData && aData.id) ? aData.id.toString() : null));
        }
        Config.aAnpRepo.id = aData.id;
        Config.aAnpRepo.name = aData.name;
        localStorage.setItem("repository_id", Config.aAnpRepo.id);
    }
    static setTemplates = (aData) =>
    {
        if (!(aData.hasOwnProperty("group")))
        {
            throw new Error("Cannot set templates! Data is not a valid group!");
        }
        Config.aTemplates = aData;
    }
    static setEntities = (aData) =>
    {
        if (!(aData.hasOwnProperty("objects") && aData.hasOwnProperty("models") && aData.hasOwnProperty("queries")))
        {
            throw new Error("Cannot set entities! 'models', 'objects' or 'queries' property is missing!");
        }
        if (!(aData.models.hasOwnProperty("group") && aData.objects.hasOwnProperty("group") && aData.queries.hasOwnProperty("items")))
        {
            throw new Error("Cannot set entities! Models, objects or queries data is not a valid data!");
        }

        Config.aEntities = aData;
    }

    // --------------------------------------------------------------------------------------------------------------

    static searchTypingDelay = 1500;
    static tokenCheckTimePeriod = 30000;
    static tokenWarningTime = 90000;

    // --------------------------------------------------------------------------------------------------------------

    static lang = {
        default: 'en',
        allowed: ['en', 'de', 'pl', 'fr', 'es'],
        selected: null
    }
    static strings = {};
    static langFileMap = {
        en: lang_en.default,
        de: lang_de.default,
        pl: lang_pl.default,
        fr: lang_fr.default,
        es: lang_es.default
    }
    static stringsLangRepoSpecific = {
        "en":
        {
            "repo":
            {
                "objects": "Objects"
            }
        },
        "de":
        {
            "repo":
            {
                "objects": "Objekte"
            }
        },
        "pl":
        {
            "repo":
            {
                "objects": "Obiekty"
            }
        },
        "fr":
        {
            "repo":
            {
                "objects": ["Objects", "Objets"]
            }
        },
        "es":
        {
            "repo":
            {
                "objects": ["Objetos"]
            }
        }
    }
    static langData = null;

    // --------------------------------------------------------------------------------------------------------------

    static helpUrls = {
        login: "https://www.boc-group.com/"
    }

    // --------------------------------------------------------------------------------------------------------------
}
export default Config;